import AlertBannerWrapper from "../components/AlertBannerWrapper/AlertBannerWrapper";
import AlertMessage from "../components/AlertMessage/AlertMessage";
import AlertCloseButton from "../components/AlertCloseButton/AlertCloseButton";
const AlertBannerWarning = ({ children, visible, onClick, visibleButton }) => {
  return (
    <AlertBannerWrapper backgroundColor={"#f14736"} visible={visible}>
      <AlertMessage>{children}</AlertMessage>
      <AlertCloseButton
        onClick={onClick}
        iconStyle={{
          fill: "#f14736",
          stroke: "#f14736",
        }}
        visibleButton={visibleButton}
      ></AlertCloseButton>
    </AlertBannerWrapper>
  );
};

AlertBannerWarning.defaultProps = {
  visible: true,
  visibleButton: true,
  onClick: () => {},
};

export default AlertBannerWarning;
